import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class OperationsPaginatorIntl extends MatPaginatorIntl {
  override readonly itemsPerPageLabel = 'Operations per page:';
}
